const isFunction = value => "function" == typeof value;

export default isFunction;
//# sourceMappingURL=isFunction.js.map